import React, { useCallback, useState, useEffect, useRef } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { MdModeEditOutline } from "react-icons/md";
import { FaAngleLeft } from "react-icons/fa";
import { Button, message, Checkbox } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  post_Restaurant,
  validateEmail,
  validateLicence,
  validateMobile,
} from "../../redux/Restaurant/RestaurantSlice";

const mapContainerStyle = {
  width: "100vw",
  height: "100vh",
};

const center = {
  lat: 40.73061,
  lng: -73.935242,
};

const options = {
  disableDefaultUI: true,
  zoomControl: true,
};

const AddRestaurant = () => {
  const dispatch = useDispatch();
  const { category_all } = useSelector((store) => store.category);

  const [messageApi, contextHolder] = message.useMessage();

  const [name, setName] = useState("");
  const [email, setemail] = useState("");
  const [emailvalid, setemailvalid] = useState("");
  const [emailError, setemailError] = useState("");
  const [number, setnumber] = useState("");
  const [numbervalid, setnumbervalid] = useState("");
  const [numberError, setnumberError] = useState("");
  const [licence, setlicence] = useState("");
  const [licencevalid, setlicencevalid] = useState("");
  const [licenceError, setlicenceError] = useState("");
  const [address, setaddress] = useState("");
  const [deliverycommission, setdeliverycommission] = useState("10");
  const [selectedCategories, setselectedCategories] = useState([]);
  const [commissionArray, setcommissionArray] = useState([]);
  const [button_press, setButton_press] = useState(false);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  useEffect(() => {
    if (button_press === true) {
      if (emailvalid === "") {
        setemailError("Enter valid Email");
      } else {
        setemailError("");
      }
      if (numbervalid === "") {
        setnumberError("Enter valid number");
      } else {
        setnumberError("");
      }
      if (licencevalid === "") {
        setlicenceError("Enter valid number");
      } else {
        setlicenceError("");
      }
    }
  }, [button_press, emailvalid, numbervalid, licencevalid]);

  const check_email = async (e) => {
    const value = e.target.value;
    setemail(value);
    setemailError("");
    if (value) {
      const verify = await dispatch(validateEmail(value));
      if (verify.payload.success === false) {
        setemailvalid(value);
        setemailError("");
      } else {
        setemailvalid("");
        setemailError(verify.payload.message);
      }
    }
  };
  const check_Mobile = async (e) => {
    const value = e.target.value;
    setnumber(value);
    setnumberError("");
    if (value) {
      const verify = await dispatch(validateMobile(value));
      if (verify.payload.success === false) {
        setnumbervalid(value);
        setnumberError("");
      } else {
        setnumbervalid("");
        setnumberError(verify.payload.message);
      }
    }
  };
  const check_licences = async (e) => {
    const value = e.target.value;
    setlicence(value);
    setlicenceError("");
    if (value) {
      const verify = await dispatch(validateLicence(value));
      if (verify.payload.success === false) {
        setlicencevalid(value);
        setlicenceError("");
      } else {
        setlicencevalid("");
        setlicenceError(verify.payload.message);
      }
    }
  };

  const handleCatSelectPress = (evt) => {
    if (selectedCategories.includes(evt)) {
      setselectedCategories(
        selectedCategories.filter((e) => {
          return e !== evt;
        })
      );
    } else {
      setselectedCategories((selectedCategories) => [
        ...selectedCategories,
        evt,
      ]);
    }
  };

  useEffect(() => {
    let commission = [];
    for (let index = 0; index < 25; index++) {
      commission = [...commission, index];
    }
    setcommissionArray(commission);
  }, []);

  const handleRestaurentPress = async () => {
    setButton_press(true);
    if (
      name !== "" &&
      emailvalid !== "" &&
      numbervalid !== "" &&
      address !== "" &&
      deliverycommission !== "" &&
      selectedCategories.length > 0 &&
      licencevalid !== ""
    ) {
      const formdata = {
        name: name,
        mobile: numbervalid,
        email: emailvalid,
        delivery_Commission: deliverycommission,
        FSSAI_Lic_No: licencevalid,
        address: address,
        categories: selectedCategories,
        status: true,
      };
      const form_posting = await dispatch(post_Restaurant(formdata));
      if (form_posting.payload.success === true) {
        messageApi.open({
          type: "success",
          content: `Restaurent add Successfully`,
        });
        setName("");
        setemail("");
        setemailvalid("");
        setemailError("");
        setnumber("");
        setnumbervalid("");
        setnumberError("");
        setlicence("");
        setlicencevalid("");
        setlicenceError("");
        setaddress("");
        setdeliverycommission("");
        setselectedCategories("");
        setButton_press(false);
      }
    }
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.65rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };

  return (
    <>
      {contextHolder}
      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add New Restaurant</h4>
            <Link to="/admin/restaurants">
              <div className="bac_add_nav">
                <span>
                  <FaAngleLeft color="#333333" />
                </span>
                <h6>Restaurant List</h6>
              </div>
            </Link>
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant Name
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Name"
                  variant="outlined"
                  error={button_press === true && name === "" ? true : false}
                  helperText={
                    button_press === true && name === "" ? "Enter Name" : ""
                  }
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  InputProps={{
                    style:
                      button_press === true && name === ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant Email
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Email"
                  variant="outlined"
                  error={emailError !== "" ? true : false}
                  helperText={emailError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_email(e)}
                  value={email}
                  InputProps={{
                    style:
                      emailError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant Number
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Number"
                  variant="outlined"
                  error={numberError !== "" ? true : false}
                  helperText={numberError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_Mobile(e)}
                  value={number}
                  InputProps={{
                    style:
                      numberError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant License
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter License"
                  variant="outlined"
                  error={licenceError !== "" ? true : false}
                  helperText={licenceError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_licences(e)}
                  value={licence}
                  InputProps={{
                    style:
                      licenceError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant Address <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-multiline-input"
                  multiline
                  rows={4}
                  placeholder="Enter Address"
                  variant="outlined"
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  error={button_press === true && address === "" ? true : false}
                  helperText={
                    button_press === true && address === ""
                      ? "Enter Address"
                      : ""
                  }
                  onChange={(e) => setaddress(e.target.value)}
                  value={address}
                  InputProps={{
                    style:
                      button_press === true && address === ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Restaurant Delivery Commission{" "}
                  <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  defaultValue="option1"
                  size="small"
                  className="input_container"
                  onChange={(e) => setdeliverycommission(e.target.value)}
                  value={deliverycommission}
                  error={
                    button_press === true && deliverycommission === ""
                      ? true
                      : false
                  }
                  helperText={
                    button_press === true && deliverycommission === ""
                      ? "Select Commission"
                      : ""
                  }
                  InputProps={{
                    style:
                      button_press === true && deliverycommission === ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                >
                  <MenuItem value="1">1</MenuItem>;
                  <MenuItem value="2">2</MenuItem>;
                  <MenuItem value="3">3</MenuItem>;
                  <MenuItem value="4">4</MenuItem>;
                  <MenuItem value="5">5</MenuItem>;
                  <MenuItem value="6">6</MenuItem>;
                  <MenuItem value="7">7</MenuItem>;
                  <MenuItem value="8">8</MenuItem>;
                  <MenuItem value="9">9</MenuItem>;
                  <MenuItem value="10">10</MenuItem>;
                </TextField>
              </div>
              <div className="input_box_container cate_list_box_res">
                <div className="menu_main_box_header">
                  <div className="mn_hd_box">
                    <div className="mn_hd_titl">
                      <h5>Categories</h5>
                    </div>
                    <div className="mn_hd_icon_box"></div>
                  </div>
                </div>
                <div className="menu_list_box">
                  <ul>
                    {category_all &&
                      category_all.map((data, index) => (
                        <li key={index}>
                          <span className="item_name">{data.name}</span>
                          <span className="item_ed_icon">
                            <Checkbox
                              className="custom-checkbox"
                              value={data.name}
                              checked={selectedCategories.includes(data.name)}
                              onChange={() => handleCatSelectPress(data.name)}
                            />
                          </span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              <div></div>
              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => handleRestaurentPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddRestaurant;
